export type ReportType = 'lawsuit' | 'incident' | 'medical';
export enum ReportTypeEnum {
  Lawsuit = 'lawsuit',
  MedicalRR = 'medical',
  Incident = 'incident',
}
